import { Component, OnInit, DoCheck} from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { Tab } from '../../model/Tab';
import { MENUS } from '../../services/global';
import { LoadService } from '../../services/load.service';
import { AuthService } from '../../services/auth.service';
import * as moment from 'moment';

@Component({
  selector: 'principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent implements OnInit, DoCheck {
  public menus;
  public tab:Tab;
  public tabs:Array<Tab>;
  public isPanel:boolean;
  public load:number;
  public todayDate:string;
  public today:number;
  public fullscreen:boolean;

  constructor(private _loaddata: LoadService,private _route: ActivatedRoute,private _router: Router, private _authService:AuthService){
    this.tabs = [];
    this.menus = MENUS;
    console.log('roles',localStorage.getItem('roles'));
    this.isPanel = true;
    this.load = 0;
    this.fullscreen = false;
    let fecha = new Date();
    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    this.todayDate = fecha.toLocaleString("es-ES",options);

    // console.log(
    //   fecha.toLocaleDateString("es-ES", options)
    // );
    /*funcion que setea la hora cada 1 segundo*/
    setInterval(() => {         //replaced function() by ()=>
      this.today = moment.now();
      //console.log(this.today); // just testing if it is working
    }, 1000);

  }

  openFullScreen(){
    document.documentElement.requestFullscreen();
    this.fullscreen = true;
  }

  closeFullScreen(){
    document.exitFullscreen();
    this.fullscreen = false;
  }

  ngOnInit() {
    if (document.fullscreenEnabled) {
    //console.log("Soporta");
}
    /*
    this._authService.getMenus().subscribe(
      (response:any) => {
        console.log(response);
      },
      (error) => {
        console.log(error);
      }
    );
    */
    if(!this._authService.isLoggedIn()){
        this._router.navigateByUrl('/login');
    }
    this._loaddata.loadChange(0);
    this._loaddata.loadCurrent.subscribe(msg => setTimeout(() => this.load = msg, 100));
  }


  public checkSession(){
    return this._authService.isLoggedIn();
  }

  ngDoCheck(){
    if(this._authService.isLogged){
      if( !this._authService.isLoggedIn()){
        this._authService.isLogged = false;
        this._router.navigateByUrl('/login');
      }
    }
  }

  logout(){
    this._authService.logout();
    this._router.navigateByUrl('/login');
  }

/**
 * [blockMenu description]
 * @param posmenu    [description]
 * @param possubmenu [description]
 */
  public blockMenu(posmenu,possubmenu):void{
    this.menus[(posmenu-1)].submenu[(possubmenu-1)].tab = !this.menus[(posmenu-1)].submenu[(possubmenu-1)].tab;
  }
  /**
   * [showSubMenu description]
   * @param op [description]
   */
  public showSubMenu(op):void{
    this.menus[(op-1)].cerrado = !this.menus[(op-1)].cerrado;
  }

/**
 * [removeTabHandler description]
 * @param tab [description]
 */
  public removeTabHandler(tab: any): void {
    let index = this.tabs.indexOf(tab);
    //console.log("tab a eliminar: ",this.tabs[index]);
    this.blockMenu(tab.posmenu,tab.possubmenu);
    if(index == 0){
      this.tabs.forEach( (tab) => {
          tab.active = false;
      });
      this.isPanel = true;
      this._router.navigate(['/']);
    }
    else{
      this.tabs.forEach( (tab) => {
          tab.active = false;
      });
      this.tabs[(index-1)].active = true;
      this._router.navigate([this.tabs[(index-1)].ruta]);
    }
    //este metodo elimina el tab que se cerró del array tabs
    this.tabs.splice(index, 1);
  }

/**
 * [cargarMenu description]
 * @param submenu [description]
 */
  public cargarMenu(submenu):void{
    this.isPanel = false;
    //console.log("tabs", this.tabs);
    this.tabs.forEach( (tab) => {
        tab.active = false;
    });
    this.tab = new Tab(submenu.nombre,true,submenu.menu,submenu.posicion,submenu.ruta,[]);
    this.tabs.push(this.tab);
    this.blockMenu(submenu.menu,submenu.posicion);

    this._router.navigate([submenu.ruta]);
  }

/**
 * [cargarTab description]
 * @param submenu [description]
 */
  public cargarTab(submenu):void{
    if(submenu != 'PaneldeControl'){
      this.isPanel = false;
      this.tabs.forEach( (tab) => {
          if(tab.nombre == submenu.nombre){
            tab.active = true
          }else{
            tab.active = false;
          }
      });
      this._router.navigate([submenu.ruta]);
    }
    else{
      this.tabs.forEach( (tab) => {
          tab.active = false;
      });
      this.isPanel = true;
      this._router.navigate(['/']);
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/principal/principal.component.ts